// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.table-container[data-v-61346dc1]{ padding : 0 5px\n}\n.custom-element-table[data-v-61346dc1]{ position: relative;\n}\n", ""]);
// Exports
module.exports = exports;
